<section
  class="relative max-sm:px-[20px] h-screen flex items-center justify-center overflow-hidden bg-primary mt-[35px]"
>
  <div
    class="absolute inset-0 bg-gradient-to-b from-transparent to-bg-primary opacity-90"
  ></div>

  <div
    class="hidden lg:block slider-container relative z-10 w-full h-full overflow-hidden px-[20px]"
  >
    <div
      #slidesContainer
      class="slides flex transition-transform duration-700 ease-in-out h-full w-full"
    >
      <div
        #slide
        class="slide flex-shrink-0 w-full flex flex-col lg:flex-row text-center lg:text-left"
        *ngFor="let s of [0, 1, 2, 3]; let i = index"
      >
        <!-- Replace with your real content logic here, if needed -->
        <div class="relative overflow-hidden">
          <!-- Slides Wrapper -->
          <div
            #slidesContainer
            class="flex transition-transform duration-700 ease-in-out text-[#fff]"
            [style.transform]="'translateX(-' + currentSlide * 100 + '%)'"
          >
            <div
              class="w-full flex-shrink-0 p-6 flex flex-col lg:flex-row items-center justify-between"
              *ngFor="let slide of slidesData; let i = index"
            >
              <div
                class="w-full lg:w-1/2 transition-all duration-700 my-5 overflow-hidden"
                [class.opacity-100]="i === currentSlide"
                [class.opacity-0]="i !== currentSlide"
              >
                <h1
                  class="text-4xl md:text-6xl font-extrabold leading-tight mb-6 text-primary"
                >
                  <span class="text-accent-blue">{{
                    slide.titleHighlight
                  }}</span>
                  <br class="hidden lg:block" />
                  {{ slide.title }}
                </h1>

                <p
                  class="text-lg md:text-xl max-w-3xl mx-auto lg:mx-0 mb-10 text-secondary opacity-90"
                >
                  {{ slide.description }}
                </p>

                <button
                  (click)="productView()"
                  class="btn-primary px-8 py-3 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
                >
                  Learn More
                </button>
              </div>

              <div class="lg:w-1/2 flex justify-center items-center p-4 md:p-8">
                <img
                  [src]="slide.imageUrl"
                  [alt]="slide.altText"
                  class="rounded-xl shadow-2xl w-full max-w-lg h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button class="slider-nav-button left" (click)="prevSlide()">
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 19l-7-7 7-7"
        ></path>
      </svg>
    </button>
    <button class="slider-nav-button right" (click)="nextSlide()">
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        ></path>
      </svg>
    </button>

    <div class="slider-dots" #sliderDotsContainer>
      <div
        *ngFor="let dot of [0, 1]; let i = index"
        class="dot w-3 h-3 rounded-full bg-white bg-opacity-50 cursor-pointer"
        [ngClass]="{ 'dot active': i === currentSlide }"
        (click)="goToSlide(i)"
      ></div>
    </div>
  </div>

  <!-- Mobile -->
  <div class="lg:hidden relative w-full overflow-hidden">
    <div
      #slidesContainer
      class="flex transition-transform duration-700 ease-in-out"
      [style.transform]="'translateX(-' + currentSlide * 100 + '%)'"
    >
      <div
        *ngFor="let slide of slidesData; let i = index"
        class="w-full flex-shrink-0 p-4 flex flex-col items-center text-center"
      >
        <img
          [src]="slide.imageUrl"
          [alt]="slide.altText"
          class="rounded-xl shadow-lg w-full max-w-sm h-auto mb-4 object-cover"
        />

        <h1 class="text-2xl font-bold mb-2 text-primary">
          <span class="text-accent-blue">{{ slide.titleHighlight }}</span
          ><br />
          {{ slide.title }}
        </h1>

        <p class="text-base text-secondary opacity-90 mb-4 px-2">
          {{ slide.description }}
        </p>

        <button
          (click)="productView()"
          class="bg-blue-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-blue-700 transition"
        >
          Request a Demo
        </button>
      </div>
    </div>

    <!-- Navigation Dots -->
    <div class="flex justify-center mt-4 space-x-2">
      <div
        *ngFor="let dot of slidesData; let i = index"
        class="w-2 h-2 rounded-full cursor-pointer"
        [ngClass]="{
          'bg-blue-500': i === currentSlide,
          'bg-gray-300': i !== currentSlide
        }"
        (click)="goToSlide(i)"
      ></div>
    </div>
  </div>
</section>
